export class OrigenDatosTransaccion {
    constructor({ tipoFrmEmpresa } = {}) {
        this.tipoFrmEmpresa = tipoFrmEmpresa;

        this.model = {
            id: {
                value: null,
                header: 'Código'
            },
            fecha: {
                value: new Date(),
                header: 'Fecha (día/mes/año):',
                required: 'Fecha es requerido'
            },
            pais: {
                value: null,
                header: 'País:',
                required: 'País es requerido'
            },
            provincia: {
                value: null,
                header: 'Provincia:',
                required: 'Provincia es requerido'
            },
            ciudad: {
                value: null,
                header: 'Ciudad:',
                required: 'Ciudad es requerida'
            },
            canton: {
                value: '',
                header: 'Ciudad',
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4
            },
            tipo_persona: {
                value: null,
                header: 'Tipo de persona:',
                required: 'Tipo de persona es requerido'
            },
            tipo_declarante: {
                value: null,
                header: 'Tipo de declarante:',
                required: 'Tipo de declarante es requerido'
            },
            compania: {
                value: '',
                header: 'Nombre de la compañía donde adquirió el bien',
                required: 'Compañía es requerido',
                maxLength: 'Máximo 500 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 500,
                min: 4
            },
            proyecto: {
                value: '',
                header: 'Proyecto',
                required: 'Proyecto es requerido',
                maxLength: 'Máximo 500 caracteres',
                minLength: 'Mínimo 3 caracteres',
                max: 500,
                min: 3
            },
            tipo_identificacion: {
                value: null,
                header: 'Tipo de Identificación',
                required: 'Tipo de identificación es requerido'
            },
            identificacion: {
                value: '',
                header: 'Identificación',
                required: 'Identificación es requerido',
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4
            },
            razon_social: {
                value: '',
                header: 'Razón social',
                required: 'Razón social es requerido',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4
            },
            nombres: {
                value: '',
                header: 'Nombres',
                required: 'Nombres es requerido',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4
            },
            apellidos: {
                value: '',
                header: 'Apellidos',
                required: 'Apellidos es requerido',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4
            },
            tipo_identificacion_rep: {
                value: null,
                header: 'Tipo de identificacion del Representante Legal / Apoderado:',
                required: 'Tipo de identificación es requerido'
            },
            identificacion_rep: {
                value: '',
                header: 'Identificación del Representante Legal / Apoderado:',
                required: 'Identificación es requerido',
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4
            },
            razon_social_rep: {
                value: '',
                header: 'Razón Social del Representante Legal / Apoderado: ',
                required: 'Razón social es requerido',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4
            },
            nombres_rep: {
                value: '',
                header: 'Nombres del Representante Legal / Apoderado: ',
                required: 'Nombres es requerido',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4
            },
            apellidos_rep: {
                value: '',
                header: 'Apellidos del Representante Legal / Apoderado: ',
                required: 'Apellidos es requerido',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4
            },
            descripcion: {
                value: '',
                header: 'Describa la transacción u operación que realiza con la compañía',
                required: 'Descripción es requerido',
                maxLength: 'Máximo 250 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 250,
                min: 4
            },
            proposito: {
                value: '',
                header: 'Propósito de la relación comercial o contractual/Motivo de la compra del bien',
                headerPorTipo: {
                    FRM_TOYOTA: 'Propósito de la relación comercial o contractual/Motivo de la compra del bien:',
                },
                required: 'Propósito es requerido',
                maxLength: 'Máximo 250 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 250,
                min: 4
            },
            ubicacion_bien: {
                value: '',
                header: 'Ubicación del bien o servicio',
                headerPorTipo: {
                    FRM_TOYOTA: 'Ubicación del bien:',
                },
                required: 'Ubicación es requerido',
                maxLength: 'Máximo 250 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 250,
                min: 4
            },
            valor_total: {
                value: 0,
                header: 'Valor total del bien/servicio:',
                required: 'Valor total del bien/servicio es requerido'
            },
            moneda: {
                value: null,
                header: 'Moneda:',
                required: 'Moneda es requerido'
            },
            pais_pago: {
                value: null,
                header: 'País de donde proviene el pago',
                required: 'País de donde proviene el pago es requerido'
            },
            provincia_pago: {
                value: null,
                header: 'Provincia de donde proviene el pago',
                required: 'Provincia de donde proviene el pago es requerido'
            },
            ciudad_pago: {
                value: null,
                header: 'Ciudad de donde proviene el pago',
                required: 'Ciudad de donde proviene el pago es requerido'
            },
            canton_pago: {
                value: '',
                header: 'Ciudad donde proviene el pago',
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4
            },
            fecha_transaccion: {
                value: new Date(),
                header: 'Fecha de la transacción u operación (día/mes/año):',
                required: 'Fecha de la transacción u operación es requerido'
            }
        };
        Object.keys(this.model).forEach((key) => {
            const campo = this.model[key];
            if (campo.headerPorTipo && tipoFrmEmpresa && campo.headerPorTipo[tipoFrmEmpresa] !== undefined) {
                campo.header = campo.headerPorTipo[tipoFrmEmpresa];
            }
        });
    }

    optionLabel = 'nombre';
}
